import React, { Component } from 'react';
import { connect } from 'react-redux';
import SettingsForm from '../../../components/advertisers/accounts/SettingsForm';

class Edit extends Component {
  render() {
    const { account } = this.props;
    
    return (
      <div>
        <SettingsForm ref='editAccountForm' account={account} onSubmit={this.onFormSubmit} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loader, advertiser: { accounts } } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};
  const isLoading = loader.includes('AccountInfoForm');
  
  return { isLoading, accounts, account };
};

export default connect(mapStateToProps)(Edit);
